import { jsx } from "react/jsx-runtime";
import React__default, { useEffect } from "react";
import { getSearchResultMessage } from "./AnnounceSearchResults.utils.js";
import { Announce } from "./Announce.js";
const AnnounceSearchResults = (props) => {
  const { searchText, results, debounce, loading = false } = props;
  const [message, setMessage] = React__default.useState("");
  const defaultDebounce = debounce || 500;
  const lastSearchText = React__default.useRef();
  const lastResults = React__default.useRef();
  useEffect(() => {
    if (lastResults.current === results && lastSearchText.current === searchText) {
      setMessage(void 0);
    }
    if (lastResults.current !== results && lastSearchText.current !== searchText) {
      setMessage(getSearchResultMessage(searchText, results, loading));
    }
    const handler = setTimeout(() => {
      setMessage(getSearchResultMessage(searchText, results, loading));
    }, defaultDebounce);
    return () => {
      clearTimeout(handler);
    };
  }, [results, searchText, loading, defaultDebounce]);
  lastResults.current = results;
  lastSearchText.current = searchText;
  return /* @__PURE__ */ jsx(Announce, { message });
};
export {
  AnnounceSearchResults
};
//# sourceMappingURL=AnnounceSearchResults.js.map
